import { Form, Formik, FormikErrors, FormikProps, FormikState } from 'formik';
import { FormInputWithLabel } from '../../../_core/form/input/form-labelled-input.component';
import { FormButton } from '../../../_core/form/button/form-button.component';
import { IRIFormProps } from '../../../_core/form/form.types';
import { FormActionsRow } from '../../../_core/form/input/form-actions-row';
import { IRequestGroupUnauthenticatedOverview } from '../../../../lib/types';

interface ISelfServeRequestGroupFormValues {
  givenName: string;
  familyName: string;
  email: string;
}

export interface ISelfServeRequestGroupFormSubmitProps extends ISelfServeRequestGroupFormValues {
  resetForm?: (_?: Partial<FormikState<ISelfServeRequestGroupFormValues>>) => void;
}

interface ISelfServeRequestGroupFormProps extends IRIFormProps<ISelfServeRequestGroupFormSubmitProps> {
  group: IRequestGroupUnauthenticatedOverview;
}

export const SelfServeRequestGroupForm = ({ group, onSubmit }: ISelfServeRequestGroupFormProps) => {
  const validateForm = (values: ISelfServeRequestGroupFormValues) => {
    const errors: FormikErrors<ISelfServeRequestGroupFormValues> = {};

    if (!values.givenName.trim()) errors.givenName = 'Required';
    if (!values.familyName.trim()) errors.familyName = 'Required';
    if (!values.email) errors.email = 'Required';

    return errors;
  };

  return (
    <Formik
      initialValues={{ givenName: '', familyName: '', email: '' }}
      onSubmit={(values, { resetForm }) =>
        onSubmit({
          givenName: values.givenName.trim(),
          familyName: values.familyName.trim(),
          email: values.email.trim(),
          resetForm
        })
      }
      validate={validateForm}
    >
      {(props: FormikProps<ISelfServeRequestGroupFormValues>) => (
        <Form action="#" method="POST" className="sm:max-w-xl mx-auto space-y-4 mt-10">
          <div>
            <p className="font-light text-sm mb-4">
              Enter your information below to request access to{' '}
              <span className="font-medium">{group.company?.name + "'s"}</span> request:{' '}
              <span className="font-bold">{group.name}</span>
            </p>
            <p className="font-light text-sm mb-4">The invite will be sent to your email.</p>
          </div>
          <FormInputWithLabel name="email" label="Email" type="email" />
          <FormInputWithLabel name="givenName" label="First Name" />
          <FormInputWithLabel name="familyName" label="Last Name" />
          <FormActionsRow>
            <FormButton loading={props.isSubmitting} text="Request Access" />
          </FormActionsRow>
        </Form>
      )}
    </Formik>
  );
};
